import React from 'react';
import styles from './styles.less';

const Loading = (props) => {
  let quips = ['Loading...'];

  let text = quips[Math.floor(Math.random() * quips.length)];

  return props.pastDelay ? (
    <div className={styles.loadingScreenContainer}>{text}</div>
  ) : null;
};

export default Loading;
